import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectTypeFilter = (store: StoreSchema) => store.licenses.type
